<script setup lang="ts">
    import { useRoute, useRouter } from 'vue-router';
    import { useLibraryStore } from '../stores/library';
    import { onMounted, ref, watch } from 'vue';
    import { IDashboard } from '../services/api/dashboard/types';
    import EchoButton from '../components/EchoButton.vue';
    import { __ } from '../stores/expressions';
    import SharedDashboardReport from '../components/public-link/SharedDashboardReport.vue';
    import { XIcon } from '@lucide/vue';

    const library = useLibraryStore();

    const route = useRoute();
    const dashboardId = route.query.id as string;

    const dashboard = ref<IDashboard | null>(null);

    const router = useRouter();

    onMounted(() => {
        if (library.dashboards.length === 0) {
            library.getDashboards();
        } else {
            findDashboard();
        }
    });

    watch(
        () => library.dashboards.length,
        () => findDashboard()
    );

    const findDashboard = () => {
        dashboard.value = library.dashboards.find((d) => d.id === dashboardId) || null;
    };

    const handleCancel = () => {
        router.push({ path: 'library' });
    };

    const handleUseDashboard = async () => {
        if (dashboard.value) {
            const res = await library.addLibraryDashboard(dashboard.value);
            if (res.id) {
                router.push({ path: 'dashboard', query: { id: res.id } });
            }
        }
    };
</script>
<template>
    <SharedDashboardReport v-if="dashboard" :dashboard="dashboard" />
    <div
        class="w-full fixed bottom-20 left-0 flex justify-center items-center gap-3 h-0 overflow-visible"
    >
        <EchoButton @click="handleCancel">
            {{ __('cancel') }}
            <template #icon-right><XIcon /></template>
        </EchoButton>
        <EchoButton @click="handleUseDashboard">
            {{ __('use') }}
        </EchoButton>
    </div>
</template>
